// extracted by mini-css-extract-plugin
export default {"bannerHeight":"50"};